export default __webpack_public_path__ + "static/media/selfie.affc7880.png";